import { render, staticRenderFns } from "./CompetitionPopupModal.vue?vue&type=template&id=00abcdc2&scoped=true"
import script from "./CompetitionPopupModal.vue?vue&type=script&lang=js"
export * from "./CompetitionPopupModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00abcdc2",
  null
  
)

export default component.exports